import {
  DIALOG_BOOLEAN_PREFIX,
  DIALOG_MAIN_KEY,
  DIALOG_NUMBER_PREFIX,
  DIALOG_PROP_PREFIX_SEPARATOR,
} from './dialogs-constants';
import { DialogKeysType } from '@routes/dialogs';

export type BuildDialogUrlPropValue = string | number | boolean;

type Options = {
  props?: Record<string, BuildDialogUrlPropValue>;
  overlap?: boolean;
  pathName?: string;
};

export function buildDialogUrl(dialogKey: DialogKeysType, options?: Options) {
  const { props, overlap = true, pathName } = options || {};
  const queryParams = new URLSearchParams(location.search);
  const allDialogKeys = queryParams.getAll(DIALOG_MAIN_KEY);

  if (overlap && !allDialogKeys.includes(dialogKey)) {
    queryParams.append(DIALOG_MAIN_KEY, dialogKey);
  } else {
    queryParams.set(DIALOG_MAIN_KEY, dialogKey);
  }

  if (props) {
    Object.entries(props).forEach(([propKey, value]) =>
      queryParams.set(
        buildDialogPropParamKey(dialogKey, propKey),
        handlePropValueTypes(value)
      )
    );
  }

  return `${pathName || location.pathname}?${queryParams.toString()}`;
}

function buildDialogPropParamKey(dialogKey: DialogKeysType, propKey: string) {
  return `${dialogKey}${DIALOG_PROP_PREFIX_SEPARATOR}${propKey}`;
}

function handlePropValueTypes(value: BuildDialogUrlPropValue) {
  if (typeof value === 'boolean') {
    return `${DIALOG_BOOLEAN_PREFIX}${value}`;
  }

  if (typeof value === 'number') {
    return `${DIALOG_NUMBER_PREFIX}${value}`;
  }

  return String(value);
}

export function buildCloseDialogUrl(dialogKey: DialogKeysType) {
  const queryParams = new URLSearchParams(location.search);
  queryParams.delete(DIALOG_MAIN_KEY, dialogKey);

  Array.from(queryParams.keys())
    .filter((key) => key.includes(dialogKey))
    .forEach((key) => queryParams.delete(key));

  return `${location.pathname}?${queryParams.toString()}`;
}

export function buildCloseAllDialogsUrl() {
  const queryParams = new URLSearchParams(location.search);
  queryParams.delete(DIALOG_MAIN_KEY);

  Array.from(queryParams.keys()).forEach((key) => queryParams.delete(key));

  return `${location.pathname}?${queryParams.toString()}`;
}
